import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

export const shipmentTrackingApi = createApi({
  reducerPath: 'shipmentTrackingApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['shipmentTracking'],
  endpoints: (builder) => ({
    getShipmentTrackingPublic: builder.query({
      query: ({ shipmentNumber, recaptchaToken }) => ({
        method: 'POST',
        path: `PublicData/SearchTracking/${shipmentNumber}`,
        data: {
          'g-recaptcha-response': recaptchaToken,
        },
      }),
      providesTags: ['shipmentTracking'],
    }),
    getShipmentTrackingAuth: builder.query({
      query: ({ shipmentNumber }) => ({
        method: 'GET',
        path: `Shipment/SearchTracking/${shipmentNumber}`,
      }),
      providesTags: ['shipmentTracking'],
    }),
  }),
});

export const shipmentTrackingReducerName = shipmentTrackingApi.reducerPath;
export const shipmentTrackingReducer = shipmentTrackingApi.reducer;
export const shipmentTrackingMiddleware = shipmentTrackingApi.middleware;

export const { 
  useLazyGetShipmentTrackingPublicQuery,
  useLazyGetShipmentTrackingAuthQuery 
} = shipmentTrackingApi;
